'use client';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import {
  StyledTipsContainer,
  TipsWrapper,
  TipsCardsWrapper,
  DesktopTitleWrapper,
  MobileTitleWrapper,
  ImageContainer,
  Title,
  TipCard,
  TipCardContent,
  Content,
} from './styles';

export const Tips = ({ cards, title }) => (
  <StyledTipsContainer>
    <MobileTitleWrapper>
      <Title>{title}</Title>
    </MobileTitleWrapper>
    <TipsWrapper>
      <DesktopTitleWrapper>
        <Title>{title}</Title>
      </DesktopTitleWrapper>
      <TipsCardsWrapper>
        {cards?.map(({ icon, content }) => (
          <TipCard key={content}>
            <TipCardContent>
              <ImageContainer>
                <ResponsiveImage
                  src={icon?.src}
                  alt={icon?.alt}
                  height={icon?.height}
                  width={icon?.width}
                />
              </ImageContainer>
              <Content>{content}</Content>
            </TipCardContent>
          </TipCard>
        ))}
      </TipsCardsWrapper>
    </TipsWrapper>
  </StyledTipsContainer>
);

Tips.displayName = 'Tips';
Tips.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      icon: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
        width: PropTypes.string,
        height: PropTypes.string,
      }),
    }),
  ),
  title: PropTypes.string,
};
